import { eLinkButtonTarget } from '../common/components/general/link-button/link-button.model';
import { SelectOption } from '../common/components/general/select/select.model';
import { ErrorData } from '../common/models/error.model';
import { UserAuthDetails, UserDetails } from '../common/models/user-details.model';

export class LoginResponse {
  results?: LoginResults;
  errorData?: ErrorData;
}

export class LoginResults {
  userName?: string;
  userType?: string;
  userFirstName?: string;
  userLastName?: string;
  userEmail?: string;
  mainSinCom?: string;
  marketCode?: string;
  telePhoneNumber?: string;
  primaryLanguage?: string;
  directoryName?: string;
  market?: string;
  region?: string;
  isAdmin?: boolean;
  dealerLists?: Dealer[];
  userPreferences?: UserPreference;
  siteSettings?: SiteSettings;
  hasMultiRole?: boolean; //This is computed value in Angular. AWS will not return this
  hasMultiBusinessOp?: boolean; //This is computed value in Angular. AWS will not return this
  old_firstName?: string;
  old_lastName?: string;
  old_username?: string;
  new_username?: string;
  old_email?: string;
  poiUserIds?: string;
  country?: string;
  isIndependentRepairer?: boolean;
}

export class Dealer {
  dealerCode?: string;
  dealerMarket?: string;
  // dealerRegion?: string;
  primaryDealer?: boolean;
  dealerShipName?: string;
  street?: string;
  state?: string;
  city?: string;
  zipCode?: string;
  roleList?: Role[];
  companyCity?: string;
  companyName?: string;
  VAT?: string;
  companyZipCode?: string;
  companyAddress?: string;
  companyCountry?: string;
}

export class Role {
  roleName?: string;
  roleLabel?: string;
  businessOp?: string;
  businessOpLabel?: string;
}

export class UserPrefResponse{
  results?: UserPreference;
  errorData?: ErrorData;
}

export class UserPreference {
  userName?: string;
  userId?: string;
  preferences?: Preferences;
  isValidate?: boolean;
  userDetails?: UserDetails;
}

export class Preferences {
  loginPreference?: LoginPreference;
  notificationPreference?: NotificationPreference;
  emailPreference?: EmailPreference;
}

export class LoginPreference {
  roleName?: string;
  roleLabel?: string;
  businessOp?: string;
  businessOpLabel?: string;
  dealerCode?: string;
  dealerShipName?: string;
  languageCode?: string;
  isAdmin?: boolean;
  isIR?: boolean;
  market?: string;
  region?: string;
}

export class NotificationPreference {
  socialMediaNotification?: boolean;
  ticketNotification?: boolean;
}

export class EmailPreference {
  emailTicketNotification?: boolean;
  emailPromotionalNotification?: boolean;
  emailsocialMediaNotification?: boolean;
}

export class SiteSettings {
  notificationRefreshTimerInSeconds?: number;
  bannerTimerInSeconds?: number;
}

export class LoginRequest {
  userName?: string;
  domain?: number;
  userType?: string;
}

export class LoginSelections {
  selectedBusinessLabel?: SelectOption;
  selectedRole?: SelectOption;
  selectedDealer?: SelectOption;
  region?: string;
  market?: string;
  userId?: string;
  isAdmin?: boolean;
  isIR?: boolean;

  constructor(obj?: Partial<LoginSelections>) {
    Object.assign(this, obj);
  }

  static create(businessOp: string, businessOpLabel: string, roleName: string = '', roleLabel: string = '', dealerCode: string = '', dealerShipName: string = '', region: string = '', market: string = '', userId: string = '', isAdmin?: boolean, isIR?: boolean ) {
    let loginSelections: LoginSelections = new LoginSelections();
    loginSelections.selectedBusinessLabel = new SelectOption(businessOp, businessOpLabel);
    loginSelections.selectedRole = new SelectOption(roleName, roleLabel);
    let dlr = `${dealerCode} - ${dealerShipName}`;
    loginSelections.selectedDealer = new SelectOption(dlr, dlr);
    loginSelections.region = region;
    loginSelections.market = market;
    loginSelections.userId = userId;
    loginSelections.isAdmin = isAdmin;
    loginSelections.isIR = isIR;
    return loginSelections;
  }
}

export class LoginLinkout {
  type: eLinkButtonTarget;
  hrefLink: string;
  text: string;
}

export class UserLookupRequest {
  username?: string;
}

export class UserLookupResponse {
  results?: UserLookupResults;
  errorData?: ErrorData;
}

export class UserLookupResults {
  username?: string;
  domain?: number;
  userType?: string;
}

export class GetAllRolesResponse {
  results?: GetAllRolesResult;
  errorData?: ErrorData;
}

export class GetAllRolesResult {
  businessUnits?: BusinessUnits[];
}

export class BusinessUnits {
  businessOp?: string;
  businessOpLabel?: string;
  roles?: Roles[];
  isAdmin?: boolean;
  isIr?: boolean;
}

export class Roles {
  roleName?: string;
  roleLabel?: string;
}

export class GetAllDealersResponse {
  results?: DealerDetails[];
  errorData?: ErrorData;
}

export class DealerDetails {
  dealerCode?: string;
  dealerMarket?: string;
  // dealerRegion?: string;
  dealerShipName?: string;
  street?: string;
  city?: string;
  zipCode?: string;
  primaryDealer?: boolean;
  state?: string;
  region?: string;
}

export class AuthGenerateResendReq {
  userDetails?: UserAuthDetails;
}

export class AuthVerifyReq {
  otpCode?: string;
  userDetails?: UserAuthDetails;
}

export class AuthResponse {
  success?: boolean;
  message?: string;
  otpCode?: string;
}

export class LanguageResponse{
  results?: LanguageResults;
  errorData?: ErrorData;
}

export class LanguageResults{
  market?: string;
  languages?: Languages[];
}

export class Languages{
  languageCode?: string;
  languageName?: string;
  languageLabel?: string;
  isDefault?: boolean;
  isoCode?: string;
}

export class LogoutResponse{
  success?: boolean;
  userName?: string;
}